import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./LeadsManagement.css";

const LeadsManagement = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newLeads, setNewLeads] = useState([]);
  const prevLeadsRef = useRef([]);

  // Fetch leads from the backend
  const fetchLeads = async () => {
    try {
      const response = await axios.get("https://api.swasthmitra.com/api/lead/admin");

      if (prevLeadsRef.current.length > 0) {
        // Identify new leads
        const newEntries = response.data.filter(
          (lead) =>
            !prevLeadsRef.current.some((prevLead) => prevLead._id === lead._id)
        );

        if (newEntries.length > 0) {
          setNewLeads((prev) => [...prev, ...newEntries]); // Store new leads
        }
      }

      setLeads(response.data);
      prevLeadsRef.current = response.data; // Store previous leads
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
    const interval = setInterval(fetchLeads, 10000); // Poll every 10 seconds

    return () => clearInterval(interval);
  }, []);

  // Handle marking a lead as contacted
  const handleCall = async (leadId) => {
    try {
      await axios.put(`https://api.swasthmitra.com/api/lead/contact/${leadId}`);
      fetchLeads(); // Refresh data after updating status
    } catch (error) {
      console.error("Error updating lead status:", error);
    }
  };

  return (
    <div className="leads-management">
      <h2>
        Manage QR POP-UP
        {newLeads.length > 0 && (
          <span className="notification-badge">{newLeads.length}</span>
        )}
      </h2>

      {/* New Leads Notification */}
      {newLeads.length > 0 && (
        <div className="notification-popup">
          <p>New User(s) Registered! Proceed with Action.</p>
          <button onClick={() => setNewLeads([])}>Dismiss</button>
        </div>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Date</th>
              <th>Action</th>
              <th>About</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((lead) => (
              <tr
                key={lead._id}
                className={
                  newLeads.some((n) => n._id === lead._id) ? "new-lead" : ""
                }
              >
                <td>{lead.name}</td>

                <td>{new Date(lead.createdAt).toLocaleDateString("en-GB")}</td>

                <td className={lead.contacted ? "contacted" : "not-contacted"}>
                  {lead.contacted ? (
                    <span className="contacted-text">
                      {lead.mobile} Contacted
                    </span>
                  ) : (
                    <div className="call-container">
                      <span className="lead-mobile">{lead.mobile}</span>
                      <a
                        href={`tel:${lead.mobile}`}
                        onClick={() => handleCall(lead._id)}
                        className="call-icon"
                      >
                        📞 Call
                      </a>
                    </div>
                  )}
                </td>
                <td>{lead.about}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LeadsManagement;
